import { Settings as SettingsIcon } from "lucide-react";
import { Card, CardBody } from "@/components/ui/Card";

export default function SettingsPage() {
  return (
    <div className="space-y-8">
      {/* Enhanced Header */}
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-600 via-gray-700 to-gray-800 p-8 text-white">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative">
          <h1 className="mb-2 text-4xl font-bold">Settings</h1>
          <p className="text-lg text-gray-100">
            Manage your application settings and preferences
          </p>
        </div>
        {/* Decorative elements */}
        <div className="absolute -right-4 -top-4 h-24 w-24 rounded-full bg-white/10"></div>
        <div className="absolute -bottom-4 -right-12 h-32 w-32 rounded-full bg-white/5"></div>
      </div>

      {/* Settings Content */}
      <Card>
        <CardBody>
          <div className="py-12 text-center">
            <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600">
              <SettingsIcon className="h-12 w-12 text-gray-600 dark:text-gray-300" />
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-900 dark:text-white">
              Settings Configuration
            </h3>
            <p className="mx-auto max-w-sm text-gray-500 dark:text-gray-400">
              Settings functionality will be implemented based on your specific
              application requirements and available APIs.
            </p>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
